<template>
  <div>
    <div v-if="!invisible">
      <v-card
        :key="randomId + '_' + done"
        width="100%"
        :max-width="maxWidth ? maxWidth : landscape ? 1150 : 800"
        flat
        tile
        color="transparent"
        class="mx-auto"
      >
        <div class="rel">
          <template v-if="temp">
            <pdf
              v-for="i in pages.nodeInfo ? pages.nodeInfo.pages : pages[0] && pages[0].nodeInfo ? pages[0].nodeInfo.pages : 1"
              :key="i"
              :src="temp"
              :page="i"
              class="mb-1"
              @loaded="onLoaded"
              @page-loaded="onProgress"
              @num-pages="onNumPages"
            />
          </template>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import pdf from 'vue-pdf'
export default {
  name: 'pdfGen',
  components: {pdf },
  props: {
    pageSize: {
      type: [String, Object],
      default: 'A4',
    },
    landscape: Boolean,
    docDefinition: {
      type: Object,
      default: () => {
        return { content: '' }
      },
    },
    contentData: {
      type: [String, Array, Object],
      default: null,
    },
    headerData: {
      type: [String, Array, Object],
      default: null,
    },
    footerData: {
      type: [String, Array, Object],
      default: null,
    },
    signature: Boolean,
    name: {
      type: String,
      default: 'optionalName',
    },
    signData: Object,
    pageMargins: {
      type: Array,
      default: () => {
        return [15, 105, 15, 30]
      },
    },
    invisible: Boolean,
    images: Object,
    columnGap: {
      type: Number,
      default: 0,
    },
    maxWidth: {
      type: [Number, String],
      default: null,
    },
  },
  data: () => ({
    documentLoaded: false,
    documentReady: false,
    temp: null,
    pages: 1,
    qq: null,
    icon: {
      logo:
        '<svg width="90" height="28" viewBox="0 0 90 28" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        '<g clip-path="url(#clip0)">\n' +
        '<path d="M6.87158 28.4914V13.1228C6.87158 10.8666 7.42954 8.64155 8.54546 6.70107C9.93784 4.29487 12.4311 1.83693 16.8545 1.61442C25.6964 1.17458 27.9835 8.51736 28.265 9.98695C28.5465 11.4565 29.5468 16.45 25.9829 20.7087C23.3741 23.8239 19.4282 24.3879 17.4979 24.4603C16.8696 24.4862 16.3518 23.9636 16.3518 23.3219V17.9352C16.3518 17.3452 16.7892 16.8485 17.3622 16.8019C18.8803 16.6725 21.5544 15.9791 21.3483 12.7088C21.0618 8.15513 16.3569 9.03999 15.3566 10.0646C15.2711 10.1525 15.1957 10.2353 15.1253 10.3129C14.5372 10.9805 14.2155 11.8602 14.2055 12.7605L14.0848 21.3452C14.0798 21.8316 14.0094 22.318 13.8737 22.7889C13.3258 24.6828 11.5464 29.1278 6.87158 28.4914Z" fill="#277FAF"/>\n' +
        '<mask id="mask0" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="6" y="1" width="23" height="28">\n' +
        '<path d="M6.88672 28.5V13.1314C6.88672 10.8753 7.44468 8.65021 8.5606 6.70973C9.95298 4.30354 12.4462 1.8456 16.8697 1.62309C25.7116 1.18325 27.9987 8.52602 28.2802 9.99561C28.5617 11.4652 29.562 16.4587 25.9981 20.7174C23.3892 23.8325 19.4433 24.3966 17.5131 24.469C16.8847 24.4949 16.367 23.9722 16.367 23.3306V17.9438C16.367 17.3539 16.8043 16.8571 17.3774 16.8106C18.8954 16.6812 21.5696 15.9878 21.3635 12.7175C21.077 8.1638 16.372 9.04866 15.3717 10.0732C15.2863 10.1612 15.2109 10.244 15.1405 10.3216C14.5524 10.9891 14.2307 11.8688 14.2206 12.7692L14.1 21.3539C14.095 21.8403 14.0246 22.3267 13.8889 22.7976C13.341 24.6915 11.5615 29.1365 6.88672 28.5Z" fill="#277FAF"/>\n' +
        '</mask>\n' +
        '<g mask="url(#mask0)">\n' +
        '<g filter="url(#filter0_d)">\n' +
        '<path d="M24.0728 3.53431C22.3788 2.3131 20.0414 1.45929 16.8545 1.6197C12.4311 1.84221 9.93784 4.30015 8.54546 6.70635C7.42451 8.64165 6.87158 10.8719 6.87158 13.128V28.4966C11.5464 29.1331 13.3308 24.6881 13.8737 22.7942C14.0094 22.3233 14.0748 21.8421 14.0848 21.3505L14.2055 12.7658C14.2155 12.15 14.3714 11.5446 14.6528 11.0116C14.6528 11.0064 14.6528 11.0064 14.6528 11.0013C15.1555 5.54206 24.0728 3.53431 24.0728 3.53431Z" fill="url(#paint0_linear)"/>\n' +
        '</g>\n' +
        '<path d="M19.5589 1.73883C18.7345 1.61464 17.8347 1.56807 16.8545 1.61464C12.4311 1.83715 9.93784 4.29509 8.54546 6.70128C7.42451 8.63659 6.87158 10.8668 6.87158 13.123V28.4916C7.21842 28.5381 7.54515 28.5537 7.85681 28.5485C11.4358 24.3622 9.32459 19.674 9.72169 13.0712C10.149 6.02341 19.5589 1.73883 19.5589 1.73883Z" fill="url(#paint1_linear)"/>\n' +
        '</g>\n' +
        '</g>\n' +
        '<path d="M41.4011 16.4411V20.8095H39.9434V9.6416H44.016C45.2258 9.6416 46.1726 9.95309 46.8564 10.5761C47.5402 11.199 47.8858 12.0271 47.8858 13.0527C47.8858 14.1391 47.5477 14.9748 46.8789 15.5598C46.2102 16.1448 45.2484 16.4411 44.001 16.4411H41.4011ZM41.4011 15.2331H44.016C44.7975 15.2331 45.3911 15.0508 45.8044 14.6786C46.2177 14.3063 46.4281 13.7669 46.4281 13.0679C46.4281 12.3994 46.2177 11.8676 45.8044 11.4725C45.3911 11.0699 44.8201 10.8648 44.0987 10.8496H41.4011V15.2331Z" fill="#277FAF"/>\n' +
        '<path d="M53.4914 13.7819C53.281 13.7439 53.0481 13.7287 52.8001 13.7287C51.8759 13.7287 51.2522 14.1238 50.9291 14.9139V20.8017H49.5239V12.5132H50.8915L50.914 13.4704C51.3724 12.7259 52.0261 12.3612 52.8677 12.3612C53.1382 12.3612 53.3486 12.3992 53.4914 12.4676V13.7819Z" fill="#277FAF"/>\n' +
        '<path d="M54.2578 16.5855C54.2578 15.7726 54.4156 15.0433 54.7312 14.3899C55.0468 13.7442 55.4901 13.2428 56.0537 12.8857C56.6173 12.5362 57.2635 12.3539 57.9848 12.3539C59.1044 12.3539 60.0061 12.7413 60.6974 13.5239C61.3887 14.3064 61.7344 15.3472 61.7344 16.6463V16.7451C61.7344 17.5504 61.5841 18.2797 61.276 18.9179C60.9679 19.556 60.5321 20.0575 59.9611 20.4145C59.39 20.7716 58.7362 20.9539 57.9999 20.9539C56.8878 20.9539 55.9861 20.5665 55.2948 19.784C54.6035 19.0014 54.2578 17.9682 54.2578 16.6767V16.5855V16.5855ZM55.6705 16.7527C55.6705 17.6719 55.8809 18.4089 56.3017 18.9711C56.7225 19.5257 57.286 19.8068 57.9999 19.8068C58.7137 19.8068 59.2773 19.5257 59.6981 18.9559C60.1188 18.3937 60.3292 17.596 60.3292 16.5855C60.3292 15.6739 60.1188 14.9369 59.6905 14.3747C59.2622 13.8126 58.6987 13.5239 57.9848 13.5239C57.2935 13.5239 56.73 13.805 56.3092 14.3595C55.8809 14.9217 55.6705 15.7195 55.6705 16.7527Z" fill="#277FAF"/>\n' +
        '<path d="M69.8113 17.8922H65.1826L64.1381 20.8095H62.6353L66.8507 9.6416H68.1281L72.3511 20.8095H70.8558L69.8113 17.8922ZM65.6184 16.6842H69.3755L67.4969 11.4573L65.6184 16.6842Z" fill="#277FAF"/>\n' +
        '<path d="M80.5577 16.7524C80.5577 18.0135 80.2721 19.0316 79.7011 19.8065C79.13 20.5814 78.356 20.9612 77.3792 20.9612C76.3798 20.9612 75.5983 20.6422 75.0272 20.004V24.0001H73.6221V12.5132H74.907L74.9746 13.4324C75.5457 12.7183 76.3422 12.3612 77.3566 12.3612C78.341 12.3612 79.1225 12.7335 79.6935 13.4856C80.2646 14.2377 80.5577 15.2861 80.5577 16.6232V16.7524ZM79.1525 16.5929C79.1525 15.6584 78.9571 14.9215 78.5589 14.3745C78.1682 13.8351 77.6196 13.5616 76.9358 13.5616C76.0867 13.5616 75.448 13.9414 75.0272 14.7011V18.6669C75.448 19.4266 76.0867 19.7989 76.9509 19.7989C77.6271 19.7989 78.1606 19.533 78.5589 18.986C78.9571 18.4542 79.1525 17.6565 79.1525 16.5929Z" fill="#277FAF"/>\n' +
        '<path d="M89.2735 16.7524C89.2735 18.0135 88.9879 19.0316 88.4168 19.8065C87.8458 20.5814 87.0718 20.9612 86.095 20.9612C85.0956 20.9612 84.3141 20.6422 83.743 20.004V24.0001H82.3379V12.5132H83.6228L83.6904 13.4324C84.2615 12.7183 85.058 12.3612 86.0724 12.3612C87.0568 12.3612 87.8383 12.7335 88.4093 13.4856C88.9804 14.2377 89.2735 15.2861 89.2735 16.6232V16.7524V16.7524ZM87.8683 16.5929C87.8683 15.6584 87.6729 14.9215 87.2747 14.3745C86.884 13.8351 86.3354 13.5616 85.6516 13.5616C84.8025 13.5616 84.1638 13.9414 83.743 14.7011V18.6669C84.1638 19.4266 84.8025 19.7989 85.6667 19.7989C86.3429 19.7989 86.8764 19.533 87.2747 18.986C87.6729 18.4542 87.8683 17.6565 87.8683 16.5929Z" fill="#277FAF"/>\n' +
        '<defs>\n' +
        '<filter id="filter0_d" x="2.87158" y="-2.39966" width="25.2012" height="34.9581" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">\n' +
        '<feFlood flood-opacity="0" result="BackgroundImageFix"/>\n' +
        '<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>\n' +
        '<feOffset/>\n' +
        '<feGaussianBlur stdDeviation="2"/>\n' +
        '<feColorMatrix type="matrix" values="0 0 0 0 0.00293403 0 0 0 0 0.0345777 0 0 0 0 0.0541667 0 0 0 0.89 0"/>\n' +
        '<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>\n' +
        '<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>\n' +
        '</filter>\n' +
        '<linearGradient id="paint0_linear" x1="6.86928" y1="15.0747" x2="24.0717" y2="15.0747" gradientUnits="userSpaceOnUse">\n' +
        '<stop stop-color="#277FAF"/>\n' +
        '<stop offset="0.3356" stop-color="#2578AD"/>\n' +
        '<stop offset="0.8385" stop-color="#1E63A6"/>\n' +
        '<stop offset="1" stop-color="#1C5BA3"/>\n' +
        '</linearGradient>\n' +
        '<linearGradient id="paint1_linear" x1="6.86928" y1="15.0733" x2="19.5569" y2="15.0733" gradientUnits="userSpaceOnUse">\n' +
        '<stop offset="8.24799e-08" stop-color="#1C5BA3"/>\n' +
        '<stop offset="0.1615" stop-color="#1E63A6"/>\n' +
        '<stop offset="0.6644" stop-color="#2578AD"/>\n' +
        '<stop offset="1" stop-color="#277FAF"/>\n' +
        '</linearGradient>\n' +
        '<clipPath id="clip0">\n' +
        '<rect width="33" height="28" fill="white"/>\n' +
        '</clipPath>\n' +
        '</defs>\n' +
        '</svg>',
      phone:
        '<svg\n' +
        '                    width="10"\n' +
        '                    height="10"\n' +
        '                    viewBox="0 0 16 17"\n' +
        '                    fill="none"\n' +
        '                    xmlns="http://www.w3.org/2000/svg"\n' +
        '                >\n' +
        '                    <path\n' +
        '                        d="M6.65074 9.39131C7.63149 10.4073 8.81817 11.1917 10.1274 11.6894L11.8987 10.2501C11.9512 10.2132 12.0135 10.1934 12.0772 10.1934C12.141 10.1934 12.2032 10.2132 12.2557 10.2501L15.5445 12.4138C15.6694 12.4905 15.7751 12.5957 15.8532 12.7212C15.9314 12.8468 15.9799 12.9891 15.995 13.1371C16.01 13.2851 15.9912 13.4346 15.9399 13.5738C15.8886 13.7131 15.8063 13.8383 15.6996 13.9395L14.1585 15.4939C13.9378 15.7166 13.6666 15.88 13.369 15.9695C13.0714 16.0591 12.7568 16.0721 12.4531 16.0072C9.42374 15.3683 6.63154 13.8721 4.39558 11.6894C2.20924 9.48499 0.696308 6.6801 0.0403042 3.61498C-0.0245005 3.30967 -0.0109749 2.99245 0.0795703 2.69406C0.170115 2.39566 0.33461 2.12621 0.557111 1.91182L2.15452 0.338198C2.25337 0.234468 2.37392 0.154917 2.50714 0.105503C2.64036 0.0560887 2.78281 0.0380915 2.92381 0.052859C3.06481 0.0676265 3.20071 0.114776 3.32134 0.190777C3.44197 0.266778 3.5442 0.369661 3.62037 0.491722L5.80975 3.80688C5.84751 3.85894 5.8679 3.92201 5.8679 3.98679C5.8679 4.05158 5.84751 4.11465 5.80975 4.1667L4.36739 5.93702C4.86802 7.24723 5.64801 8.42719 6.65074 9.39131Z"\n' +
        '                        fill="#4F4F4F"\n' +
        '                    />\n' +
        '                </svg>',
      email:
        '<svg\n' +
        '                    width="10"\n' +
        '                    height="10"\n' +
        '                    viewBox="0 0 17 17"\n' +
        '                    fill="none"\n' +
        '                    xmlns="http://www.w3.org/2000/svg"\n' +
        '                >\n' +
        '                    <path\n' +
        '                        d="M8.20599 3.36845C9.5038 3.36845 10.7267 3.93288 11.6229 4.81522V4.81782C11.6229 4.39411 11.9135 4.07359 12.3151 4.07359H12.4171C13.0508 4.07359 13.1778 4.65991 13.1778 4.84492L13.1805 11.4299C13.1364 11.8614 13.6347 12.0845 13.9114 11.8072C14.9872 10.7216 16.2765 6.22081 13.2416 3.61496C10.4111 1.18266 6.6123 1.58448 4.59255 2.94995C2.44583 4.40506 1.07366 7.61911 2.40652 10.6398C3.8621 13.9331 8.02325 14.9155 10.4999 13.9357C11.7536 13.439 12.3315 15.0995 11.0284 15.643C9.06447 16.4649 3.59117 16.381 1.03488 12.0381C-0.692159 9.10444 -0.600788 3.94382 3.98163 1.27022C7.48405 -0.776415 12.1052 -0.209382 14.891 2.64402C17.8022 5.6298 17.6338 11.2162 14.7917 13.3879C13.5045 14.3756 11.5931 13.415 11.6069 11.9761L11.5926 11.507C10.6964 12.3779 9.5038 12.8887 8.20599 12.8887C5.63855 12.8887 3.37815 10.6706 3.37815 8.15435C3.37815 5.61104 5.63855 3.36949 8.20599 3.36949V3.36845ZM11.4354 7.97246C11.3381 6.12909 9.94366 5.01899 8.25859 5.01899H8.19484C6.25265 5.01899 5.17372 6.51996 5.17372 8.22158C5.17372 10.1296 6.47683 11.3345 8.18687 11.3345C10.0956 11.3345 11.3488 9.96437 11.4401 8.34354L11.4354 7.97246Z"\n' +
        '                        fill="#4F4F4F"\n' +
        '                    />\n' +
        '                </svg>',
    },
    done: false,
    isActive: false,
    pdfDocGenerator: null,
    pdfDocGenerator1: null,
    blob: null,
    base64: null,
    buffer: null,
    styles: {
      margin: {
        margin: 10,
      },
      text: {
        fontSize: 10,
        lineHeight: 1,
        color: '#333333',
      },
      text_lh: {
        fontSize: 10,
        lineHeight: 1.2,
        color: '#333333',
      },
      black: {
        fontSize: 10,
        lineHeight: 1,
        color: '#4F4F4F',
        bold: true,
      },
      primary_color: {
        color: '#277faf',
      },
      small: {
        fontSize: 9,
        color: '#4F4F4F',
      },
      header: {
        fontSize: 10,
        lineHeight: 1.4,
        color: '#333333',
      },
      header_black_12: {
        fontSize: 12,
        lineHeight: 1.4,
        color: '#4F4F4F',
        bold: true,
      },
      header_black: {
        fontSize: 10,
        lineHeight: 1.4,
        color: '#4F4F4F',
        bold: true,
      },
      h9: {
        fontSize: 9,
        lineHeight: 1.4,
        color: '#333333',
      },
      h8: {
        fontSize: 8,
        lineHeight: 1.4,
        color: '#333333',
      },
      h9bold: {
        fontSize: 9,
        lineHeight: 1.4,
        color: '#333333',
        bold: true,
      },
      mt: {
        margin: [0, 6, 0, 0],
      },
      roboto: {
        font: 'Roboto',
      },
      'roboto-black': {
        font: 'Roboto',
        bold: true,
      },
      roboto_light: {
        font: 'Roboto',
        italics: true,
      },
      bold: {
        bold: true,
      },
      h10: {
        fontSize: 10,
      },
      h11: {
        fontSize: 11,
      },
      h12: {
        fontSize: 12,
      },
      h14: {
        fontSize: 14,
      },
      h22: {
        fontSize: 22,
      },
      lh12: {
        lineHeight: 1.2,
      },
      lh14: {
        lineHeight: 1.4,
      },
      lh16: {
        lineHeight: 1.6,
      },
      lh18: {
        lineHeight: 1.8,
      },
      'color-black': {
        color: 'black',
      },
    },
    test: [],
    loadPage: 1,
    loadPercent: 0,
    loadedRatio: 0,
    pagesPdf: 0,
  }),
  created() {
    if (!this.invisible)
      this.onExtendPdfLoader({id: this.randomId, created: false, pages: 0, pageLoaded: 0})
    this.pdfMake.vfs = this.pdfFonts.pdfMake.vfs
    this.pdfMake.fonts = {
      Gotham: {
        normal: 'Gotham-Regular.ttf',
        bold: 'Gotham-Medium.ttf',
      },
      Roboto: {
        light: 'Roboto-Light.ttf',
        normal: 'Roboto-Medium.ttf',
        bold: 'Roboto-Medium.ttf',
        italics: 'Roboto-Light.ttf',
        bolditalics: 'Roboto-Medium.ttf',
      },
    }
    if (this.companiesConfig && this.companiesConfig.logo) {
      this.pdfgen()
    }
  },
  watch: {
    signData() {
      this.pdfgen()
    },
    companiesConfig: {
      deep: true,
      handler() {
        if (this.companiesConfig && this.companiesConfig.logo) {
          this.pdfgen()
        }
      },
    },
    loadPercent() {
      if (!this.invisible)
      this.onExtendPdfLoader({id: this.randomId, created: true, pages: 0, pageLoaded: 0})
    },
  },
  computed: {
    ...mapGetters(['companiesConfig']),
    randomId() {
      let min = Math.ceil(1)
      let max = Math.floor(1000)
      return 'table_' + Math.floor(Math.random() * (max - min + 1)) + min
    },
    pdfMake() {
      return require('pdfmake/build/pdfmake.js')
    },
    pdfFonts() {
      return require('./fonts.js')
    },
    header() {
      return (
        this.headerData || {
          style: 'header',
          columns: [
            {
              table: {
                widths: ['*', 450],
                body: [
                  [
                    {
                      image: 'logo',
                      fit: [150, 60],
                      margin: [15, 10, 10, 10],
                    },
                    [
                      {
                        text: this.companiesConfig.company_name,
                        margin: [0, 22, 15, 5],
                        alignment: 'right',
                      },
                      {
                        text: this.companiesConfig.registration_address_street,
                        margin: [0, 0, 15, 0],
                        alignment: 'right',
                      },
                      {
                        text: this.companiesConfig.registration_address_zip + ' ' + this.companiesConfig.registration_address_city,
                        margin: [0, 0, 15, 10],
                        alignment: 'right',
                      },
                    ],
                  ],
                ],
              },
              layout: {
                hLineColor: '#d2d5d9',
                vLineWidth: function (i) {
                  return 0
                },
                hLineWidth: function (i) {
                  return i === 0 ? 0 : 0.25
                },
              },
            },
          ],
        }
      )
    },
    content() {
      return (
        this.contentData || [
          {
            text: 'no data',
          },
        ]
      )
    },
    signatureBlock() {
      return (
        this.footerData || {
          style: 'text',
          columns: [
            {
              table: {
                widths: [15, 'auto', 15, 'auto', 35, '*', 120, 50],
                heights: [20, 10],
                body: [
                  [
                    {
                      text: this.localStorage.translations.pages.finance['period-table']['sign-date'],
                      colSpan: 5,
                      border: [false, false, false, false],
                    },
                    '',
                    '',
                    '',
                    '',
                    {
                      text: '',
                      border: [false, false, false, false],
                    },
                    {
                      text: this.localStorage.translations.pages.finance['period-table']['sign'],
                      border: [false, false, false, false],
                    },
                    {
                      text: '',
                      border: [false, false, false, false],
                    },
                  ],
                  [
                    {
                      text: this.signData ? this.signData.date.split('.')[0] : '',
                      border: [false, false, false, true],
                    },
                    {
                      text: '/',
                      border: [false, false, false, false],
                    },
                    {
                      text: this.signData ? this.signData.date.split('.')[1] : '',
                      border: [false, false, false, true],
                    },
                    {
                      text: this.signData ? '' : '20',
                      border: [false, false, false, false],
                    },
                    {
                      text: this.signData ? this.signData.date.split('.')[2] : '',
                      border: [false, false, false, true],
                    },
                    {
                      text: '',
                      border: [false, false, false, false],
                    },
                    {
                      text: this.signData
                        ? this.signData.first_name + ' ' + this.signData.last_name
                        : '',
                      border: [false, false, false, !!(this.signData && this.signData.first_name)],
                    },
                    {
                      [this.signData ? 'image' : 'text']: this.signData ? this.signData.image : '',
                      // fit: [70, 70],
                      width: this.signData && this.signData.first_name ? 50 : 150,
                      height: 34,
                      margin: [
                        this.signData && this.signData.first_name ? 0 : -133,
                        this.signData && this.signData.first_name ? -24 : -15,
                        50,
                        this.signData && this.signData.first_name ? 0 : -9
                      ],
                      border: [false, false, false, !!(this.signData && this.signData.first_name)],
                    },
                  ],
                ],
              },
              layout: {
                hLineColor: '#d2d5d9',
                paddingLeft: function () {
                  return 0
                },
                paddingRight: function () {
                  return 0
                },
                paddingBottom: function () {
                  return 0
                },
              },
              margin: [15, 20, 15, 20],
            },
          ],
        }
      )
    },
    footer() {
      return (
        this.footerData || {
          style: 'header',
          columns: [
            {
              table: {
                widths: ['*', 'auto', 'auto'],
                body: [
                  [
                    {
                      svg: this.icon.logo,
                      fit: [100, 20],
                      margin: [12, 2, 0, 0],
                      border: [false, true, false, false],
                    },
                    {
                      columns: [
                        {
                          width: 10,
                          svg: this.icon.phone,
                        },
                        {
                          text: this.companiesConfig.phone,
                          link: 'tel:' + this.companiesConfig.phone,
                          margin: [3, 1, 0, 0],
                        },
                      ],
                      margin: [0, 8, 5, 0],
                      border: [false, true, false, false],
                    },
                    {
                      columns: [
                        {
                          width: 10,
                          svg: this.icon.email,
                        },
                        {
                          text: this.companiesConfig.email,
                          margin: [5, 0, 0, 0],
                        },
                      ],
                      margin: [0, 8, 15, 0],
                      border: [false, true, false, false],
                    },
                  ],
                ],
              },
              layout: {
                hLineColor: '#d2d5d9',
                hLineWidth: function (i) { return 0.25 },
              },
            },
          ],
        }
      )
    },
  },
  methods: {
    ...mapActions(['onExtendPdfLoader', 'onDeleteItemPdfLoader']),
    onLoaded() {
      this.documentLoaded = true
    },
    onNumPages(p) {
      if (p) {
        this.pagesPdf = p
        if (!this.invisible)
        this.onExtendPdfLoader({id: this.randomId, pages: p})
      }
    },
    onProgress(p) {
      if (p) {
        if (!this.invisible)
        this.onExtendPdfLoader({id: this.randomId, pageLoaded: p})
        if (this.pagesPdf === p) {
          setTimeout(() => {
            this.onDeleteItemPdfLoader(this.randomId)
          }, 600)
        }
      }
    },
    getBase64() {
      if (this.base64) {
        return this.base64
      }
    },

    getBlob() {
      if (this.blob) {
        return this.blob
      }
    },

    getBuffer() {
      if (this.buffer) {
        return this.buffer
      }
    },

    onDownload() {
      if (this.pdfDocGenerator) {
        this.pdfDocGenerator.download(this.name)
      }
    },

    async pdfgen() {
      this.documentReady = false
      this.temp = null
      let feet = []
      if (this.signature) {
        feet.push(this.signatureBlock)
      }
      feet.push(this.footer)

      const pdfData = {
        bufferPages: true,
        pageSize: this.pageSize,
        background: this.header,
        content: this.content,
        pageOrientation: this.landscape ? 'landscape' : 'portrait',
        pageBreakBefore: function (
          currentNode,
          followingNodesOnPage,
          nodesOnNextPage,
          previousNodesOnPage,
        ) {
          return currentNode.headlineLevel === 1 && followingNodesOnPage.length === 0
        },
        header: function (currentPage, pageCount, pageSize) {
          return {
            text: currentPage + ` / ` + pageCount,
            margin: [0, 90, 15, 0],
            alignment: 'right',
            style: 'header',
          }
        },
        footer: feet,
        images: { logo: this.companiesConfig.logo.png },
        styles: this.styles,
        pageMargins: this.signature ? [15, 105, 15, 110] : this.pageMargins,
        defaultStyle: { font: 'Gotham', columnGap: this.columnGap },
      }

      if (this.images) {
        Object.assign(pdfData.images, this.images)
      }
      this.pdfDocGenerator = this.pdfMake.createPdf(pdfData)
      this.pdfDocGenerator.getDataUrl(dataUrl => {
        this.temp = dataUrl
        this.buffer = dataUrl
        if (this.base64) this.documentReady = true
      }, {progressCallback: progress => {
        let p = (progress * 100).toFixed(0)
          this.loadPercent = p
        }})

      this.pages = this.pdfDocGenerator.docDefinition.content[0]
      this.done++
      this.pdfDocGenerator.getBase64((data) => {
        this.base64 = 'data:application/pdf;base64,' + data
        if (this.temp) this.documentReady = true
      })

      let tmp = this.pdfMake.createPdf(pdfData)
      tmp.getBlob((blob) => {
        this.blob = blob
      })
      return true
    },
  },
}
</script>

<style scoped lang="scss">
.rel {
  overflow: hidden;
  width: 100%;
  height: 100%;
}

iframe {
  width: 100%;
}
</style>
